import { Container, Grid, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import Listagem from "./Listagem";
import { useState } from "react";
import DialogIncluirLancamento from "../DialogIncluirLancamento";
import PermissionGuard from "../../../../../components/PermissionGuard";

export default function ExtratoContas() {

  const [openIncluirLancamento, setOpenIncluirLancamento] = useState(false);

  return (
    <>
      <ScreenBanner title="Financeiro" />
      <PermissionGuard permissionId="financeiro.caixa-bancos-extrato-contas">
        <Container maxWidth="lg" sx={{ mt: 5 }}>
          <Typography textAlign="center" variant="h5" mb={3}>
            Extrato de contas
          </Typography>

          <Grid container spacing={3} justifyContent="center">

            <Grid size={{ xs: 12 }}>
              <Listagem />
            </Grid>
          </Grid>
        </Container>

        {openIncluirLancamento && (
          <DialogIncluirLancamento
            open={openIncluirLancamento}
            handleClose={() => setOpenIncluirLancamento(false)}
          />
        )}

      </PermissionGuard>

    </>
  );
}
